const HERO_IMG =
  'https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20illustration%2C%20a%20large%20cut%20watermelon%20slice%20standing%20upright%20in%20center%2C%20surrounded%20by%20floating%20chat%20bubbles%20and%20small%20star%20sparks%2C%20warm%20cream%20paper%20texture%20background%2C%20flat%20vector%20style%20with%20smooth%20gradients%2C%20color%20palette%20of%20deep%20green%20and%20vivid%20coral%20orange%20and%20warm%20amber%2C%20soft%20shadows%2C%20premium%20print%20aesthetic%2C%20no%20text&width=1200&height=1280&seq=hero-melon-cover&orientation=portrait';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-accent-200/40 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-primary-200/40 blur-3xl"></div>

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-4 pb-14 pt-24 md:grid-cols-[1.05fr_0.95fr] md:gap-14 md:px-6 md:pb-24 md:pt-32">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1.5 text-sm font-medium text-secondary-800">
            <i className="ri-fire-line"></i>
            全网吃瓜第一现场
          </span>
          <h1 className="mt-6 font-heading text-4xl font-bold leading-[1.15] tracking-tight text-foreground-950 md:text-5xl">
            在海角吃瓜，
            <br />
            学会<em className="not-italic text-primary-600">有边界地围观</em>这个世界
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            这里是海角吃瓜指南页：把<strong className="font-semibold text-foreground-800">入门、怎么玩、攻略、教程</strong>与
            <strong className="font-semibold text-foreground-800">技巧、规则</strong>整理成一套清爽的图文手册，
            帮新老用户从零开始，快速上手、理性围观。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#howto"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-base font-semibold text-white transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              海角吃瓜怎么玩
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#guides"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-background-100 px-6 py-3 text-base font-semibold text-foreground-800 transition-colors hover:bg-background-200 whitespace-nowrap"
            >
              浏览攻略合集
            </a>
          </div>

          <dl className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4 border-t border-background-200 pt-6">
            <div>
              <dt className="text-sm text-foreground-500">入门手册</dt>
              <dd className="mt-1 font-heading text-2xl font-semibold text-foreground-950">6+</dd>
            </div>
            <div>
              <dt className="text-sm text-foreground-500">持续更新</dt>
              <dd className="mt-1 font-heading text-2xl font-semibold text-primary-600">每周</dd>
            </div>
            <div>
              <dt className="text-sm text-foreground-500">栏目定位</dt>
              <dd className="mt-1 font-heading text-2xl font-semibold text-accent-600">理性围观</dd>
            </div>
          </dl>
        </div>

        <div className="relative">
          <div className="absolute -right-4 -top-4 rounded-full bg-accent-500 px-4 py-1.5 text-sm font-semibold text-white shadow-none">
            今日 09 · 09
          </div>
          <div className="overflow-hidden rounded-3xl bg-background-100">
            <img
              src={HERO_IMG}
              alt="海角吃瓜 海角吃瓜攻略 海角吃瓜教程 海角吃瓜怎么玩"
              title="海角吃瓜 海角吃瓜攻略 海角吃瓜教程 海角吃瓜怎么玩"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-5 left-5 flex items-center gap-3 rounded-xl bg-background-50 px-4 py-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
              <i className="ri-quill-pen-line text-xl"></i>
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-900">编辑部说</p>
              <p className="text-xs text-foreground-500">围观有度，吃瓜有理</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}